// Module
var code = `<div class="form-section">
	<h2 class="section-header" ng-if="\$ctrl.formTitle">{{\$ctrl.formTitle}}</h2>
	<div ng-transclude></div>
</div>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/common/form-section/form-section.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;